import { useCallback } from "react";
import { useReplaceStatePath } from "./useReplaceStatePath";

export function useUpdateStateUrl() {
  const replaceStatePath = useReplaceStatePath();

  const updateStateUrl = useCallback(
    (urlStateUpdate: { [key: string]: any }, to?: string, keep: boolean = false) =>
      replaceStatePath({ pathname: to ?? window.location.pathname, urlStateUpdate, keep }),
    [replaceStatePath]
  );

  return updateStateUrl;
}
